<template>
    <div>
        <consultorias
            :consultorias="solicitacoes"
            :solicitacoes="true"
            :fornecedor="true"
            titulo="APP SEBRAE - SOLICITAÇÕES"
            v-show="mostrarConsultorias"
            @atualizar-listagem="obterSolicitacoes()"
        >
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('APPSE-FORN-CONS-00')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalhar(data.consultoriaId)"
                    ></i>
                </span>
            </template>
        </consultorias>
        <router-view></router-view>
    </div>
</template>

<script>
import ConsultoriasServicos from './ConsultoriasServicos'
import Consultorias from '../../componentes/consultorias/Consultorias'

export default {
    data() {
        return {
            solicitacoes: []
        }
    },
    methods: {
        obterSolicitacoes() {
            this.$store.dispatch('addRequest')
            ConsultoriasServicos.obterTodasSolicitacoes().then(response => {
                if (response) {
                    if (response.success) {
                        this.solicitacoes = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalhar(consultoriaId) {
            this.$router.push({
                name: 'AppSebrae_Consultorias_Fornecedor_Solicitacoes_Detalhar',
                params: {
                    consultoriaId: consultoriaId
                }
            })
        }
    },

    created() {
        this.obterSolicitacoes()
    },

    computed: {
        mostrarConsultorias() {
            return (
                this.$route.name ===
                'AppSebrae_Consultorias_Fornecedor_Solicitacoes'
            )
        }
    },

    components: {
        Consultorias
    },

    watch: {
        $route(to) {
            if (to.name === 'AppSebrae_Consultorias_Fornecedor_Solicitacoes') {
                if (this.$store.getters.recarregar) {
                    this.obterSolicitacoes()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    }
}
</script>
